<template>
    <v-app id="us-join-company">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goHome">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;">邀请加入</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>
        <v-content style="padding-top:1rem;">
            <v-container style="margin-top:5.5rem;">
                <div style="text-align:center;">
                  <!-- <i style="font-size:10rem;color:#03A9F4;" class="fa fa-share-alt-square" aria-hidden="true" /> -->
                  <img width="160" height="160" src="/res/favicon.png"/>
                </div>
                <div style="text-align:center;margin-top:1rem;font-weight: bold;">
                  <div v-if="inivteState === 400 || inivteState === 401" style="color:#F56C6C;">
                      邀请无效.
                  </div>
                  <div v-else-if="inivteState === 402" style="color:#606266;">
                      邀请过期了.
                      <p style="margin-top: 10px;margin-bottom: 10px;color: #606266;">《{{company.COMPANY_NAME}}》企业</p>
                      <p style="color: #606266;">到期时间：{{$moment(shareRecord.SHARE_EXPIRY_TIME).format("YYYY-MM-DD HH:mm:ss")}}</p>
                  </div>
                  <div v-else-if="inivteState === 403" style="color:#606266;">
                      您已经加入 <p style="margin: 0;display: inline-block;">《{{company.COMPANY_NAME}}》</p>
                  </div>
                  <div v-else-if="inivteState === 200">
                    <div style="color:#606266;">
                      《{{company.COMPANY_NAME}}》 企业邀请您加入.
                    </div>
                    <div style="margin:auto;margin-top:1rem;text-align:center;">
                      <!-- <div><v-btn large color="success" style="width:50%;font-weight:bold;" @click="submit" :disabled="btnDisabled" >同意加入</v-btn></div>
                      <div><v-btn large color="#f2f2f2" style="width:50%;margin-top:1.1rem;color:#4caf50;font-weight:bold;" @click="rejectJoin" :disabled="btnDisabled" >拒绝加入</v-btn></div> -->
                      <div>
                        <v-btn large class="secondary us-btn-style" @click="submit" :disabled="btnDisabled" >同意加入</v-btn>
                      </div>
                      <div>
                        <v-btn large color="error" class="us-btn-style" @click="rejectJoin" :disabled="btnDisabled" >拒绝加入</v-btn>
                      </div>
                    </div>
                  </div>
                  <div v-else style="color:#606266;">[{{inivteState}}]</div>
                  <div v-if="inivteState !== 200" class="text-center">
                    <v-btn
                      color="blue-grey"
                      class="white--text us-btn-style"
                      large
                      @click="goHome"
                    >
                      返回主页
                    </v-btn>
                  </div>
                </div>
            </v-container>
        </v-content>
    </v-app>

</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      company: {},
      role: 'common',
      btnDisabled: false,
      inivteState: 0,
      strRes: '',
      shareRecord: {},
      companyCode: '',
      shareCode: ''
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.companyCode = that.$route.query.company_code
    that.getShareRecord()
  },
  created() {
  },
  methods: {
    goHome: function() {
      var that = this;
      that.$router.replace('/Home')
    },
    getShareRecord() {
      var that = this
      var share_code = that.$route.query.share_code
      that.shareCode = share_code
      if (!share_code || share_code === '') {
        that.inivteState = 400
        return
      }
      that.$api.bz.getShareRecord({ code: share_code }).then(res => {
        that.strRes = JSON.stringify(res)
        if (!res.success) {
          that.getformatState(res.error_msg)
          return
        }
        that.shareRecord = res.data
        that.getCompanyShare();
      })
    },
    submit() {
      var that = this
      that.$api.bz.joinCompany({ code: that.company.COMPANY_CODE, role: that.role }).then(res => {
        if (!res.success) {
          that.$toast.warning('加入企业失败');
          return
        }
        that.btnDisabled = true
        // that.$toast.success('加入成功');
        // setTimeout(function() {
        //   that.goHome()
        // }, 1500);
        that.$AppHelper.pullUserCustomData();
        that.$AppHelper.pullNewUserToken();
        that.$router.goActionResPage({ tag: 1, text: '加入成功', auto_ret: 'a' })
      })
    },
    getCompanyShare() {
      var that = this
      that.$api.bz.getCompanyShare({ code: that.companyCode }).then(res => {
        that.strRes = JSON.stringify(res)
        if (!res.success) {
          that.getformatState(res.error_msg)
          return
        }
        var data = res.data
        that.company = data.company
        that.inivteState = data.invite_state
      })
    },
    getformatState(errMsg) {
      var that = this
      var errCode = errMsg.substr(1, 3)
      if (errCode === '401') {
        that.inivteState = 401
      } else if (errCode === '402') {
        that.inivteState = 402
        that.getCompany();
      } else if (errCode === '403') {
        that.inivteState = 403
      } else {
        that.inivteState = 400
      }
    },
    rejectJoin() {
      var that = this
      that.btnDisabled = true
      that.$router.goActionResPage({ tag: 0, text: '已拒绝加入', auto_ret: 'a' })
    },
    getCompany() {
      var that = this
      that.$api.bz.getShareRecordAndCompany({ code: that.shareCode, companyCode: that.companyCode }).then(res => {
        if (!res.success) {
          return
        }
        var data = res.data
        that.company = data.company
        that.shareRecord = data.record
      })
    }
  }
}
</script>

<style scoped>
.us-join-company{

}
.secondary {
    background-color: #5cbbf6 !important;
    border-color: #5cbbf6 !important;
}
.us-btn-style {
  font-size: 16px;
  width: 90%;
  font-weight: bold;
  margin-top: 1.1rem;
  text-align: center;
}
</style>
